// extracted by mini-css-extract-plugin
export default {"wrap":"PH-z"};